function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M31.1,158.4c-2.9,0-5.2-2.4-5.2-5.2c0-10.5,4.8-20.2,13.1-26.5c0.6-0.5,1-1.2,1-2s-0.3-1.5-0.9-2 c-6.5-5.7-10.2-14-10.2-22.6c0-16.5,13.4-30,29.9-30.2h0.4c16.4,0,30,13.4,30.2,29.8c0.1,8.8-3.6,17.2-10.2,23.1 c-0.6,0.5-0.9,1.2-0.9,2s0.4,1.5,1,2c8.4,6.4,13.2,16.1,13.2,26.6c0,2.9-2.4,5.2-5.2,5.2H31.1V158.4z M59.2,130.2 c-6.1,0-11.9,2.4-16.2,6.7c-2.1,2.1-3.8,4.6-4.9,7.4c-0.3,0.8-0.2,1.7,0.2,2.4c0.5,0.7,1.3,1.1,2.1,1.1h37.5c0.9,0,1.7-0.4,2.1-1.1 c0.5-0.7,0.6-1.6,0.2-2.4c-1.1-2.8-2.8-5.2-4.9-7.4C71.1,132.6,65.3,130.2,59.2,130.2z M59.2,80.2c-10.9,0-19.8,8.9-19.8,19.8 s8.9,19.8,19.8,19.8S79,110.9,79,100S70.1,80.2,59.2,80.2z M114.1,149c-0.3,0-0.6-0.3-0.6-0.6V139c0-0.3,0.3-0.6,0.6-0.6h59.4 c0.3,0,0.6,0.3,0.6,0.6v9.4c0,0.3-0.3,0.6-0.6,0.6H114.1z M114.1,124c-0.3,0-0.6-0.3-0.6-0.6V114c0-0.3,0.3-0.6,0.6-0.6h59.4 c0.3,0,0.6,0.3,0.6,0.6v9.4c0,0.3-0.3,0.6-0.6,0.6H114.1z M114.1,99c-0.3,0-0.6-0.3-0.6-0.6V89c0-0.3,0.3-0.6,0.6-0.6h59.4 c0.3,0,0.6,0.3,0.6,0.6v9.4c0,0.3-0.3,0.6-0.6,0.6H114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M12.5,183.4c-6.3,0-11.5-5.2-11.5-11.5v-125c0-6.3,5.2-11.5,11.5-11.5H75c2.3,0,4.1-1.9,4.1-4.1V18.8 c0-6.3,5.2-11.5,11.5-11.5h18.8c6.3,0,11.5,5.2,11.5,11.5v12.5c0,2.3,1.9,4.1,4.1,4.1h62.5c6.3,0,11.5,5.2,11.5,11.5v125 c0,6.3-5.2,11.5-11.5,11.5H12.5z M15.6,45.9c-2.3,0-4.1,1.9-4.1,4.1v118.8c0,2.3,1.9,4.1,4.1,4.1h168.8c2.3,0,4.1-1.9,4.1-4.1V50 c0-2.3-1.9-4.1-4.1-4.1H125c-2.3,0-4.1,1.9-4.1,4.1v3.1c0,4.6-3.8,8.4-8.4,8.4h-25c-4.6,0-8.4-3.8-8.4-8.4V50c0-2.3-1.9-4.1-4.1-4.1 H15.6z M93.8,17.8c-2.3,0-4.1,1.9-4.1,4.1v25c0,2.3,1.9,4.1,4.1,4.1h12.5c2.3,0,4.1-1.9,4.1-4.1v-25c0-2.3-1.9-4.1-4.1-4.1 C106.3,17.8,93.8,17.8,93.8,17.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.4a2d7063c75bf62a7b9c226bcf00d6d5.svg";
export { ForwardRef as ReactComponent };